import { createStyles } from '@material-ui/core/styles';

export const styles = () =>
  createStyles({
    root: {
      height: 52,
      width: 60,
    },
  });